import { gql } from "@apollo/client"

export const StaffProcessHighwayFragment = gql`
  fragment ProcessHighway on Hiring {
    companyProcess {
      steps {
        name
        progress

        staffNotes {
          id
          totalCount
          postingContext
        }
      }
    }

    employeeProcess {
      steps {
        name
        progress

        staffNotes {
          id
          totalCount
          postingContext
        }
      }
    }
  }
`
